// extracted by mini-css-extract-plugin
export default {"l":"e4c893e495"};